import {
  FormDropdown,
  FormInput,
  FormRadio,
  validateRequired,
  validateRequiredDropdown,
} from 'components/shared/Forms/ReduxForm'
import { I18n } from 'lib/i18n'
import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Field, reduxForm } from 'redux-form'
import { createCategory } from 'redux/categories'
import { Button, Divider, Form, Modal } from 'semantic-ui-react'

const i18nkey = 'admin.product.categories.newCategoryModal.'

const mapStateToProps = (state, ownProps) => {
  const form = state.form[ownProps.form]
  const formValues = state.form && form && form.values
  const paths = [{ value: -1, text: I18n.t('global.no_category') }].concat(
    state.categories.paths
  )
  return { form, formValues, paths }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      createCategory,
    },
    dispatch
  )
}

class NewCategoryModal extends React.Component {
  render() {
    const {
      formValues,
      paths,
      createCategory,
      destroy,
      initialized,
      form,
    } = this.props
    const hasErrors =
      !!(form && form.syncErrors) ||
      (formValues &&
        formValues.type === 'virtual' &&
        formValues.link_target_id === -1)
    const filteredPaths = paths.filter(
      (path) => path && (path.text.match(/\\/g) || []).length < 2
    )
    return (
      <Modal open={initialized} className="inverted">
        <Modal.Header>{I18n.t(i18nkey + 'title')}</Modal.Header>
        <Modal.Content>
          <Modal.Description>
            <Form>
              <Form.Group widths="equal">
                <Field
                  component={FormInput}
                  name="title_de"
                  icon="flag"
                  placeholder={I18n.t('global.title_de')}
                  validate={validateRequired}
                />
                <Field
                  component={FormInput}
                  name="title_fr"
                  icon="flag outline"
                  placeholder={I18n.t('global.title_fr')}
                  validate={validateRequired}
                />
              </Form.Group>

              <Field
                label={I18n.t(i18nkey + 'create_in')}
                component={FormDropdown}
                fluid
                search
                selection
                placeholder={I18n.t('admin.productCategorySelector.select')}
                options={filteredPaths}
                onChange={(event, newValue, previousValue) => {
                  console.log(newValue)
                }}
                name="parent_id"
                validate={validateRequiredDropdown}
              />

              <Divider />

              <Form.Group inline>
                <Field
                  component={FormRadio}
                  label={I18n.t(i18nkey + 'standard')}
                  name="type"
                  option="standard"
                />
                <Field
                  component={FormRadio}
                  label={I18n.t(i18nkey + 'virtual')}
                  name="type"
                  option="virtual"
                />
              </Form.Group>

              <Field
                label={I18n.t(i18nkey + 'link_with')}
                disabled={formValues && formValues.type === 'standard'}
                component={FormDropdown}
                fluid
                search
                selection
                placeholder={I18n.t('admin.productCategorySelector.select')}
                options={paths}
                name="link_target_id"
                onChange={(event, newValue, previousValue) => {
                  console.log(newValue)
                }}
              />
            </Form>
          </Modal.Description>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={(event) => {
              event.preventDefault()
              destroy()
            }}
            color="black">
            {I18n.t('admin.user.button.cancel')}
          </Button>
          <Button
            onClick={(event) => {
              event.preventDefault()
              createCategory(formValues)
              destroy()
            }}
            positive
            icon="checkmark"
            labelPosition="right"
            content={I18n.t('admin.user.button.save')}
            disabled={hasErrors}
          />
        </Modal.Actions>
      </Modal>
    )
  }
}

NewCategoryModal = connect(mapStateToProps, mapDispatchToProps)(
  NewCategoryModal
)
NewCategoryModal = reduxForm({ form: 'add_category_modal' })(NewCategoryModal)
export default NewCategoryModal



// WEBPACK FOOTER //
// ./src/components/admin/Categories/NewCategoryModal.jsx